import { Copy } from '../types/copy';

export const msaCopy: Copy = {
  repairServiceName: 'Value in Partnership',
  repairServiceShortName: 'Value in Partnership',
  privacyAndSecurityLink: 'https://msainsurance.com/sites/default/files/Terms_and_Conditions.pdf',
};
